import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Alert } from 'reactstrap'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

export default class Form extends Component {
  render() {
    const { errorMessage } = this.props

    return (
      <form id="login" className="form-signin form-signin-register" onSubmit={this.handleSubmit}>
        <h2 className="form-signin-heading">Register</h2>
        <h6 className="form-signin-subheading">Create your account</h6>
        <p>
          <label htmlFor="inputRegisterEmail" className="sr-only">Email address</label>
          <input type="email" id="inputRegisterEmail" className="form-control" placeholder="Email address" required autoComplete="off"/>
        </p>
        <p>
          <label htmlFor="inputRegisterFirstName" className="sr-only">First Name</label>
          <input type="text" id="inputRegisterFirstName" className="form-control" placeholder="First name" required autoComplete="off"/>
        </p>
        <p>
          <label htmlFor="inputRegisterLastName" className="sr-only">Last Name</label>
          <input type="text" id="inputRegisterLastName" className="form-control" placeholder="Last Name" required autoComplete="off"/>
        </p>
        <p>
          <label htmlFor="inputRegisterPassword" className="sr-only">Password</label>
          <input type="password" id="inputRegisterPassword" className="form-control" placeholder="Password" required autoComplete="new-password"/>
        </p>
        <p>
          <label htmlFor="inputRegisterLaboratory" className="sr-only">Laboratory</label>
          <select type="text" id="inputRegisterLaboratory" className="form-control" placeholder="Laboratory" required autoComplete="off">
            <option value="" disabled selected>Organization</option>
            <option value="LRCS">LRCS (Amiens)</option>
            <option value="LG2A">LG2A (Amiens)</option>
            <option value="ICMCB">ICMCB (Bordeaux)</option>
            <option value="LEPMI">LEPMI (Marseille)</option>
            <option value="IEMN">IEMN (Grenoble)</option>
            <option value="ICR">ICR (Lille)</option>
            <option value="MADIREL">MADIREL (Lille)</option>
            <option value="ICGM">ICGM (Montpellier)</option>
            <option value="IS2M">IS2M (Mulhouse)</option>
            <option value="IMN">IMN (Nantes)</option>
            <option value="CEMHTI">CEMHTI (Orléans)</option>
            <option value="CDF">CDF (Paris)</option>
            <option value="LCMCP">LCMCP (Paris)</option>
            <option value="IRCP">IRCP (Paris)</option>
            <option value="PHENIX">PHENIX (Paris)</option>
            <option value="IPREM">IPREM (Pau)</option>
            <option value="CIRIMAT">CIRIMAT (Toulouse)</option>
          </select>
        </p>
        <p>
          <label htmlFor="inputRegisterPermanent" className="sr-only">Are you permanent ?</label>
          <select type="text" id="inputRegisterPermanent" className="form-control" required autoComplete="off">
            <option value="" selected disabled>Are you permanent ?</option>
            <option value="true">Permanent</option>
            <option value="false">Not permanent</option>
          </select>
        </p>
        <p>
        <Link className="text-dark" style={{float: 'right'}} to="/login">Back to login</Link>
        <Button className="btn" color="primary" type="submit">Ask for register</Button></p>
        {errorMessage ? <Alert color="danger">{errorMessage}</Alert> : null}
      </form>
    )
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const creds = {
      email: event.target.inputRegisterEmail.value.trim(),
      firstName: event.target.inputRegisterFirstName.value.trim(),
      lastName: event.target.inputRegisterLastName.value.trim(),
      password: event.target.inputRegisterPassword.value.trim(),
      laboratory: event.target.inputRegisterLaboratory.value.trim(),
      permanent: event.target.inputRegisterPermanent.value.trim()
    }
    this.props.onRegisterClick(creds)
  }
}

Form.propTypes = {
  onRegisterClick: PropTypes.func.isRequired,
  errorMessage: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/containers/login/registerForm.js